"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.effectiveQualificationQuestions = exports.defaultQualificationQuestions = void 0;
/** Seed from the existing checkout questions. A false telemed flag is NOT a non-Rx classification. */
function defaultQualificationQuestions(product) {
    if (product.productType === 'supply' || product.productType === 'lab')
        return [];
    const basic = [
        { id: 'takingMedications', prompt: 'Are you currently taking any medications?', required: true, detailsWhen: true, detailsPrompt: 'Please list your current medications', reviewWhen: true },
        { id: 'hasAllergies', prompt: 'Do you have any known allergies?', required: true, detailsWhen: true, detailsPrompt: 'Please describe your allergies', reviewWhen: true },
    ];
    if (product.prescriberOptional === true)
        return basic;
    return [
        { id: 'hasCancer', prompt: 'Do you currently have cancer?', required: true, reviewWhen: true },
        { id: 'isPregnantOrBreastfeeding', prompt: 'Are you pregnant or breastfeeding?', required: true, sex: 'female', reviewWhen: true },
        { id: 'hasProstateIssues', prompt: 'Do you have any prostate issues?', required: true, sex: 'male', reviewWhen: true },
        { id: 'hasThyroidCondition', prompt: 'Do you have a thyroid condition?', required: true, reviewWhen: true },
        ...basic,
        ...(product.isPeptide ? [{ id: 'isFirstTimePeptides', prompt: 'Is this your first time taking peptides?', required: true }] : []),
    ];
}
exports.defaultQualificationQuestions = defaultQualificationQuestions;
function effectiveQualificationQuestions(product) {
    return product.qualificationQuestions ?? defaultQualificationQuestions(product);
}
exports.effectiveQualificationQuestions = effectiveQualificationQuestions;
//# sourceMappingURL=productQualification.js.map